import React from 'react';
import { FormattedMessage } from 'react-intl';
import { QuickSelectOption, MSG } from './types';
import s from './styles';

type QuickSelectSidebarProps = {
  options: QuickSelectOption[];
  subtitles: React.ReactNode[];
  disabledOptions: boolean[];
  onSelect: (option: QuickSelectOption) => void;
};

const QuickSelectSidebar: React.FC<QuickSelectSidebarProps> = ({ options, subtitles, disabledOptions, onSelect }) => (
  <div style={s.sidebar}>
    <div style={s.sidebarTitle}>
      <FormattedMessage id={MSG.quickSelectTitle} />
    </div>
    {options.map((option, index) => {
      const subtitle = subtitles[index];
      const disabled = disabledOptions[index];
      return (
        <button
          key={option.labelId}
          type="button"
          className="rbh-drp-v2-sidebar-btn"
          onClick={() => !disabled && onSelect(option)}
          style={{ ...s.sidebarBtn, ...(disabled && { opacity: 0.4, cursor: 'not-allowed' }) }}
        >
          <div style={s.sidebarBtnInner}>
            <span style={s.sidebarBullet}>•</span>
            <div>
              <div style={s.sidebarItemLabel}>
                <FormattedMessage id={option.labelId} />
              </div>
              {subtitle && <div style={s.sidebarItemSubtitle}>{subtitle}</div>}
            </div>
          </div>
        </button>
      );
    })}
  </div>
);



export default QuickSelectSidebar;
